import { IPagination } from "@fl/shared/src/types/pagination";
import React from "react";
import { Pagination, PaginationProps } from "react-bootstrap";

interface IProps extends PaginationProps, IPagination {}

const PaginationComp: React.FC<IProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  itemsPerPageOptions = [25, 50, 100, 200, 300, 400, 500],
  onPageChange,
  onItemsPerPageChange,
  ...rest
}) => {
  const handleFirst = () => onPageChange(1);
  const handlePrev = () => onPageChange(currentPage - 1);
  const handleNext = () => onPageChange(currentPage + 1);
  const handleLast = () => onPageChange(totalPages);

  const pagesArray = [];
  for (let i = 1; i <= totalPages; i++) {
    pagesArray.push(i);
  }

  const handleItemsPerPageSelect = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newValue = parseInt(e.target.value, 10);
    onItemsPerPageChange(newValue);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div>
        <span className="me-2">Itens por página:</span>
        <select
          value={itemsPerPage}
          onChange={handleItemsPerPageSelect}
          disabled={totalPages === 0}
        >
          {itemsPerPageOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      <div style={{ alignSelf: "center" }}>
        <Pagination {...rest}>
          <Pagination.First
            onClick={handleFirst}
            disabled={currentPage === 1 || totalPages === 0}
          />
          <Pagination.Prev
            onClick={handlePrev}
            disabled={currentPage === 1 || totalPages === 0}
          />

          {pagesArray.map((page) => (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Pagination.Item>
          ))}

          <Pagination.Next
            onClick={handleNext}
            disabled={currentPage === totalPages || totalPages === 0}
          />
          <Pagination.Last
            onClick={handleLast}
            disabled={currentPage === totalPages || totalPages === 0}
          />
        </Pagination>
      </div>
    </div>
  );
};

export default PaginationComp;
